import { render, staticRenderFns } from "./NewBroadcast.vue?vue&type=template&id=2634bdfd&"
import script from "./NewBroadcast.vue?vue&type=script&lang=js&"
export * from "./NewBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./NewBroadcast.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports